import React from 'react';
import PropTypes from 'prop-types';

class DropdownMultiItemFilterComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { handleClick, assoc } = this.props;
    handleClick(assoc, false);
  }

  render() {
    const { assoc } = this.props;
    return (
      <li>
        <button
          type="button"
          onClick={this.handleClick}
        >
          {assoc.Name}
        </button>
      </li>
    );
  }
}

DropdownMultiItemFilterComponent.propTypes = {
  handleClick: PropTypes.func.isRequired,
  assoc: PropTypes.shape({
    Checked: PropTypes.bool.isRequired,
    ID: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
};

DropdownMultiItemFilterComponent.displayName = 'DropdownMultiItemFilterComponent';

export default DropdownMultiItemFilterComponent;
